function indexController($rootScope, $scope,indexService , menuService){
    $scope.menus = []
    $scope.user = {}

    $rootScope.$watch('token', function(newValue, oldValue) {
        if(newValue != oldValue){
            $scope.user = $rootScope.user;

            menuService.get()
            .then((menus) => {
                $scope.menus = menus;
            })
        }
    })
    $rootScope.$on("USER_LOGGED", function(value){
        menuService.get()
        .then((menus) => {
            $scope.menus = menus;
        })
    })
    // menuService.get()
    // .then((menus) => {
    //     $scope.menus = menus;
    //     // console.log(menus);
    // })

    $scope.signOut = indexService.signOut;
}

indexController.$inject = ['$rootScope', '$scope', 'indexService', 'menuService']

app.controller('indexController', indexController)
